export const QUERY_JOB_MODEL = 'jobModel';
export const QUERY_JOBS = 'jobs';
export const QUERY_OPEN_JOBS = 'openJobs';
